import { useContext } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { UNIFIED_VISUALIZATION_PROTOTYPE } from '../../../constants/gates';
import { getChart } from 'reporting-data/report/reportGetters';
import { PIE, DONUT, GAUGE, VENN } from 'reporting-data/constants/chartTypes';
const IN_DEVELOPMENT_CHARTS = [PIE, DONUT, VENN];
const RELEASED_CHARTS = [GAUGE];
const checkUnifiedReportVizEnabled = (useUnifiedVisualization, report, gates) => {
  const chart = getChart(report);
  const chartType = chart && chart.get('chartType');
  return useUnifiedVisualization || RELEASED_CHARTS.includes(chartType) || gates && gates.includes(UNIFIED_VISUALIZATION_PROTOTYPE) && IN_DEVELOPMENT_CHARTS.includes(chartType);
};
export const useIsUnifiedReportVizEnabled = (report, runtimeOptions = {}) => {
  const {
    useUnifiedVisualization
  } = runtimeOptions;
  const {
    gates
  } = useContext(UserInfoContext);
  return checkUnifiedReportVizEnabled(useUnifiedVisualization, report, gates);
};
export const __TESTABLE__ = {
  checkUnifiedReportVizEnabled
};